"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledInvalidFeedback = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const config_1 = require("../../assets/styles/config");
exports.StyledInvalidFeedback = styled_components_1.default.div `
  display: block;
  font: 12px ${config_1.fontFamilies.primary};
  margin-top: 5px;
`;
